var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgArrow = function SvgArrow(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 8,
    fill: "none",
    viewBox: "0 0 12 8",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0c2632",
    d: "M9.459 4.565H.938a.54.54 0 0 1-.401-.162.54.54 0 0 1-.162-.4q0-.24.162-.401a.54.54 0 0 1 .4-.162H9.46L6.989.97a.53.53 0 0 1-.165-.39.58.58 0 0 1 .165-.4A.57.57 0 0 1 7.39 0a.53.53 0 0 1 .401.169l3.36 3.359a.62.62 0 0 1 .191.475.62.62 0 0 1-.192.475L7.791 7.835A.54.54 0 0 1 7.394 8a.56.56 0 0 1-.405-.176.6.6 0 0 1-.168-.396.52.52 0 0 1 .168-.395z"
  })));
};
export default SvgArrow;